// @flow
// Global Translations
import { GlobalLocale } from "./Global/Global.locale";
// Error Pages Translations
import { ErrorPagesLocale } from "./ErrorPages/ErrorPages.locale";
// Public Pages Translations
import { NavbarLocale } from "./Navbar/Navbar.locale";
import { FooterLocale } from "./Footer/Footer.locale";
import { LandingPageLocale } from "./PublicPages/LandingPage.locale";
import { AboutPageLocale } from "./PublicPages/AboutPage.locale";
import { ContactPageLocale } from "./PublicPages/ContactPage.locale";
import { HrSolutionsPageLocale } from './PublicPages/HrSolutionsPage.locale';
import { InventoryCountProcessPageLocale } from './PublicPages/InventoryCountProcessPage.locale';

// Public Account Pages Translations
import { InitialRequestLocale } from "./PublicAccountPages/InitialRequest.locale";
import { CompanyRegisterLocale } from "./PublicAccountPages/CompanyRegister.locale";
import { UserRegisterLocale } from "./PublicAccountPages/UserRegister.locale";
import { LoginLocale } from "./PublicAccountPages/Login.locale"

export const locale = {
  GlobalLocale,
  ErrorPagesLocale,
  NavbarLocale,
  FooterLocale,
  LandingPageLocale,
  AboutPageLocale,
  HrSolutionsPageLocale,
  InventoryCountProcessPageLocale,
  ContactPageLocale,
  InitialRequestLocale,
  CompanyRegisterLocale,
  UserRegisterLocale,
  LoginLocale
};



// WEBPACK FOOTER //
// ./src/Locales/index.js